import { useCallback, useRef } from "react";
import { ChatPage } from "./components/ChatPage";
import { Composer, type ComposerHandle } from "./components/Composer";
import { DetailPage } from "./components/DetailPage";
import { useChat } from "./useChat";
import { useRoute } from "./useRoute";

export default function App() {
  const { route, navigate } = useRoute();
  const { turns, suggestions, busy, send, reset } = useChat();
  const composer = useRef<ComposerHandle>(null);

  const openListing = useCallback(
    (id: string) => {
      navigate(`/listing/${id}`);
      window.scrollTo(0, 0);
    },
    [navigate],
  );

  const backToChat = useCallback(() => navigate("/"), [navigate]);

  // From a listing page: return to the thread with a question ready to send.
  const askAbout = useCallback(
    (question: string) => {
      navigate("/");
      composer.current?.prefill(question);
    },
    [navigate],
  );

  const onDetail = route.name === "detail";

  return (
    <>
      <header className="topbar">
        <button className="brand" type="button" onClick={backToChat}>
          <span className="brand-mark" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 11.5 12 4l9 7.5" />
              <path d="M5.5 10V19a1 1 0 0 0 1 1H10v-5h4v5h3.5a1 1 0 0 0 1-1v-9" />
            </svg>
          </span>
          <span className="brand-name">Loop</span>
          <span className="brand-city">Toronto, ON</span>
        </button>

        {onDetail ? (
          <button className="ghost-btn" type="button" onClick={backToChat}>
            Back to results
          </button>
        ) : (
          <button className="ghost-btn" type="button" onClick={reset} disabled={busy || turns.length === 0}>
            New search
          </button>
        )}
      </header>

      {onDetail ? (
        <DetailPage id={route.id} onOpen={openListing} onBack={backToChat} onAsk={askAbout} />
      ) : (
        <>
          <ChatPage turns={turns} busy={busy} onSend={send} onOpen={openListing} />
          <Composer ref={composer} busy={busy} suggestions={suggestions} onSend={send} />
        </>
      )}
    </>
  );
}
